import * as React from "react";
import { PureComponent } from "react";
import AppContext from "../../context/AppContext";
import "./style.scss";

class StatystykiSkasowane extends PureComponent {
  static contextType = AppContext;

  render() {
    const { airports, routes, airlines, aircrafts } = this.context;
    const liczbaLotnisk = airports.filter(
      (airport: any) => airport.isAvailable && airport.isCanceledAirport
    ).length;
    const liczbaLotow = routes.reduce(
      (subSum: any, route: any) => subSum + route.canceledFlights,
      0
    );
    const filteredAirlines = airlines.filter(
      (airline: any) => airline.canceledFlights > 0
    );
    const liczbaLinii = filteredAirlines.length;
    const linie = filteredAirlines.sort(
      (a: any, b: any) =>
        a.canceledFlights === b.canceledFlights
          ? a.name < b.name
            ? -1
            : 1
          : a.canceledFlights > b.canceledFlights
            ? -1
            : 1
    );
    const filteredAircrafts = aircrafts.filter(
      (aircraft: any) => aircraft.canceledFlights > 0
    );
    const liczbaSamolotow = filteredAircrafts.length;
    const samoloty = filteredAircrafts.sort(
      (a: any, b: any) =>
        a.canceledFlights === b.canceledFlights
          ? a.name < b.name
            ? -1
            : 1
          : a.canceledFlights < b.canceledFlights
            ? 1
            : -1
    );
    return (
      <section className="Statystyki">
        <p className="Statystyki_item">Lotniska: {liczbaLotnisk}</p>
        <p className="Statystyki_item">Loty: {liczbaLotow}</p>
        <p className="Statystyki_item">Linie lotnicze: {liczbaLinii}</p>
        <div className="Statystyki_item">
          <ul className="Statystyki_list">
            {linie.map((linia: any) => (
              <li key={linia.id}>
                {linia.name} ({linia.canceledFlights})
              </li>
            ))}
          </ul>
        </div>
        <p className="Statystyki_item">Samoloty: {liczbaSamolotow}</p>
        <div className="Statystyki_item">
          <ul className="Statystyki_list">
            {samoloty.map((samolot: any) => (
              <li key={samolot.id}>
                {samolot.name} ({samolot.canceledFlights})
              </li>
            ))}
          </ul>
        </div>
      </section>
    );
  }
}

export default StatystykiSkasowane;
